import { CampaignTypeEnum, MessageTypeEnum, SystemNumberStatusEnum } from '@gr/shared/enums';
import * as yup from 'yup';

export interface IGsdClientLocalSystemNumberRecord {
  id: string;
  phoneNumber: number;
  status: SystemNumberStatusEnum;
  grTcrCampaignId: string;
  tcrCampaignId: string;
  campaignType: CampaignTypeEnum;
  messageType: MessageTypeEnum;
  providerId: string;
  providerName: string | null;
  providerProfileId: string;
}

export interface IGsdClientLocalSystemNumbersRequest {
  clientId: string;
  offset: number;
  limit: number;
}

export interface IGsdClientLocalSystemNumbersResponse {
  totalCount: number;
  records: IGsdClientLocalSystemNumberRecord[];
}

export const GSD_CLIENT_LOCAL_SYSTEM_NUMBERS_DEFAULT_LIMIT = 25;
export const GSD_CLIENT_LOCAL_SYSTEM_NUMBERS_MAX_LIMIT = 1000;

export const gsdClientLocalSystemNumbersRequestSchema: yup.SchemaOf<IGsdClientLocalSystemNumbersRequest> = yup.object({
  clientId: yup.string().uuid().required(),
  offset: yup.number().integer().min(0).default(0),
  limit: yup
    .number()
    .integer()
    .min(1)
    .max(GSD_CLIENT_LOCAL_SYSTEM_NUMBERS_MAX_LIMIT)
    .default(GSD_CLIENT_LOCAL_SYSTEM_NUMBERS_DEFAULT_LIMIT),
});
